module.exports = __webpack_public_path__ + "c0fbbfa077ac0ebb0ef9fca8d47f0d16.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/saxophone.png
// module id = 2429
// module chunks = 0